/**
 * LandingCourses mobile accordion.
 *
 * Markup contract (per `Views/Partials/blocklist/Components/landingCoursesSection.cshtml`):
 *   <div class="amri-hero-mobile">
 *     <div class="amri-hero-accordion-mobile">
 *       <ul>
 *         <li>
 *           <div class="amri-accordion-toggler amri-accordion-toggler-active">ACLS</div>
 *           <div class="amri-hero-carousel-slider-red amri-accordion-content-container">...</div>
 *         </li>
 *         <li>
 *           <div class="amri-accordion-toggler">PALS</div>
 *           <div class="amri-hero-carousel-slider-purple amri-accordion-content-container">...</div>
 *         </li>
 *         ... BLS, BUNDLE
 *       </ul>
 *     </div>
 *   </div>
 *
 * Behavior: only one item open at a time. Clicking a toggler:
 *   - if already active: collapse it (close all)
 *   - else: move `.amri-accordion-toggler-active` to clicked toggler; show only
 *     its sibling `.amri-accordion-content-container`
 *
 * Replaces the Phase 3.3 CSS workaround in `v2-overrides.css` that hard-hid
 * non-first `.amri-accordion-content-container` elements.
 */

const TOGGLER = '.amri-hero-mobile .amri-hero-accordion-mobile .amri-accordion-toggler';
const ACTIVE_CLASS = 'amri-accordion-toggler-active';
const CONTENT_CLASS = 'amri-accordion-content-container';

function findContent(toggler: Element): HTMLElement | null {
    let sibling: Element | null = toggler.nextElementSibling;
    while (sibling) {
        if (sibling.classList.contains(CONTENT_CLASS)) {
            return sibling as HTMLElement;
        }
        sibling = sibling.nextElementSibling;
    }
    return null;
}

function setOpen(togglers: HTMLElement[], openIndex: number | null): void {
    togglers.forEach((toggler, i) => {
        const isOpen = i === openIndex;
        toggler.classList.toggle(ACTIVE_CLASS, isOpen);
        const content = findContent(toggler);
        if (content) {
            content.style.display = isOpen ? '' : 'none';
        }
    });
}

export function initAccordion(): void {
    const togglers = Array.from(document.querySelectorAll<HTMLElement>(TOGGLER));
    if (togglers.length === 0) {
        return;
    }

    let openIndex: number | null = togglers.findIndex(t =>
        t.classList.contains(ACTIVE_CLASS)
    );
    if (openIndex === -1) {
        openIndex = 0;
    }
    setOpen(togglers, openIndex);

    togglers.forEach((toggler, i) => {
        toggler.addEventListener('click', () => {
            openIndex = openIndex === i ? null : i;
            setOpen(togglers, openIndex);
        });
    });
}
